<!--
 * @Description: (弹框)分账设置组件
 * @Author: sunhuihong
 * @Date: 2022-10-11 17:43:52
 * @LastEditTime: 2023-02-13 14:05:11
-->
<template>
  <div class="sharing-setup-body">
    <el-dialog width="864px" title="分账设置" :visible.sync="visible" :close-on-click-modal="false"
      @open="initData" :before-close="handleCancel" center>
      <el-form :rules="rules" :model="ruleForm" ref="ruleForm" :label-position="labelPosition" 
        style="margin-bottom: 60px;">
        <div class="section-item">
          <div class="section-item-head">
		        <div class="blue-line"></div>
		        <span>时间设置</span>
		      </div>
          <el-form-item label="订单完成："  class="section-item-form-item">
            <el-input-number v-model="ruleForm.orderCompleteStartTime" :disabled="!canSharingCfg" 
              :min="0"  label="订单完成" :precision="0" @change="changeLedgerDays">
            </el-input-number>
            <span style="margin: 0 19px 0 11px;">天</span>
            <span>后可支持分账</span>
          </el-form-item>
          <div  class="section-item-form-item des-style">
            如订单完成后用户仍需退款，请在{{ruleForm.orderCompleteStartTime}}日内退款。订单完成{{ruleForm.orderCompleteStartTime}}日后，管理端可手动分账
          </div>
          <el-form-item label="订单完成："  class="section-item-form-item" style="margin-top: 30px;">
            <el-input-number v-model="ruleForm.orderCompleteEndTime" :disabled="!canSharingCfg" 
              :min="Number(ruleForm.orderCompleteStartTime) + 1"  label="订单完成" :precision="0">
            </el-input-number>
            <span style=" margin:0 19px 0 11px;">天</span>
            <span>后可自动分账</span>
          </el-form-item>
          <div  class="section-item-form-item des-style">如不手动分账，则系统 {{ruleForm.orderCompleteEndTime}} 日后自动分账</div>
        </div>
        <div class="section-item">
          <div class="section-item-head" style="margin-top: 60px;">
		        <div class="blue-line"></div>
		        <span>比例设置</span>
            <el-popover placement="right" title="" width="360" trigger="hover"
              content="设置分成比例后，所有订单均默认按照比例进行分成。若个别服务不适用，请在编辑服务-套餐模块新增服务分成。">
              <span slot="reference">
                <img style="width: 18px; height: 18px; margin-left: 11px; vertical-align: middle;" 
                  src="@/assets/common/icon-common-question-mark.png" alt="">
              </span>
            </el-popover>
		      </div>
          <el-form-item  style="margin: 30px 0 0 14px; width: 260px; " v-if="revenueSharingCfgList" prop="checkSharingType">
            <el-checkbox-group v-model="ruleForm.checkSharingType" :min="0" :max="2" @change="changeSharingType">
              <el-checkbox v-for="(item, index) in revenueSharingCfgList"  :disabled="item.type != 3 ? false : true || !canSharingCfg" 
                :label="item.type" :key="index" style="display: block; margin-bottom: 8px;">
                <span class="sharing-content-label" :style="{'color' : item.type != 3 ? '#657180' : '#B6BDCE','margin-left': item.type != 3 
                  ? '0': '-12px'}">
                  {{item.type == 1 ? '本平台' : item.type == 2 ? '机构' : item.type == 3 ? '个人' : '' }}
                </span>
                <span  v-if="item.type != 3" >:</span>
                <el-input v-if="item.type != 3" style="width: 160px; margin-left: 8px;"  maxlength="5" size="small"  
                  @input="inputSharingRatio(item.ratioStr, index)" v-model="item.ratioStr" :disabled="!canSharingCfg">
                  <template slot="append">%</template>
                </el-input>
                <span v-else>(派单人、接单人、代理人等)</span>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
      </el-form>
      <div  class="dialog-footer bk-wizard-bottons">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" v-if="canSharingCfg" @click="handleSave('ruleForm')">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import Util from '@/global/Util.js'

export default {
  name: 'SharingSetup',
  props: ["visible", "instId", "mchId", "canSharingCfg"],

  data() {
		let validateCheckSharingType = (_rule, _value, callback) => {
			if (this.ruleForm.checkSharingType.length == 0) {
        callback(new Error('请设置分账比例！'));
      } else if (this.checkedSharingData.findIndex(item => item.ratioStr == '') !== -1) {
        callback(new Error('分账比例不能为空！'));
      } else if (this.ruleForm.checkSharingType.length) {
        let scaleSum =  this.checkedSharingData.reduce((sum, e) => sum + Number(e.ratioStr || 0), 0);
        if (Number(scaleSum) != Number(this.maxScale)) {
          callback(new Error('分账比例总和必须等于100%！'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    
    return {
      labelPosition: 'left',
      maxScale: 100,//比例最大不能超过100%
      ruleForm: {
        orderCompleteStartTime: '',
        orderCompleteEndTime: '',
        checkSharingType: [],//选中的checkbox(v-model绑定的数据，每一项是string / number / boolean)
      },
      sharingTypeList: [],//默认比例设置分类数据[{type :''}]
      revenueSharingCfgList: [],//编辑时已经存在的比例设置数据
      checkedSharingData: [],//选中的比例数据
      rules: {
        checkSharingType: [
          { type: 'array', required: true, validator: validateCheckSharingType, trigger: 'blur' }
        ]
      }
    }
  },
  
  methods: {
    initData() {
      let params = {instId: this.instId};
			let header = this.encryptionUtil.signatureParams(params,
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: Constant.URL_LIST_INST_REVENUE_SHARING_CFGS,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.ruleForm.orderCompleteStartTime = Object.values(result.data.timeMap)[0];
        this.ruleForm.orderCompleteEndTime = Object.values(result.data.timeMap)[1];
        this.sharingTypeList = this.handleSetSharingRate(result.data.typeMap);
        if (result.data.revenueSharingCfgList.length) {
          this.getEditSharingSetupData(result.data);
        } else {
          this.revenueSharingCfgList = this.sharingTypeList;
        }
      });
    },

    getEditSharingSetupData(data) {
      let revenueSharingCfgList = this.sharingTypeList.map((item,index) => {
        return {...item, ...data.revenueSharingCfgList[index]};
      });
      this.ruleForm.checkSharingType = data.revenueSharingCfgList.map(item => {return item.type});
      this.revenueSharingCfgList = revenueSharingCfgList;
    },

    //设置设置分成比例
    handleSetSharingRate (data) {
      let scaleSettingsList = [];
      for (let key in data) {
        scaleSettingsList.push({
          id : '',
          institutionId : this.instId,
          ratioStr : '',
          type : Number(key)
        })
      }
      return scaleSettingsList;
    },

    //输入比率(例如22.50)整数位不能大于3位,小数点后2位
    inputSharingRatio(value, index) {
		  this.revenueSharingCfgList[index].ratioStr =  Util.limitInputTwoDecimal(this.commonUtil.filterDigitals(value, ['.']));
      if (index == 0 && parseFloat(this.revenueSharingCfgList[index].ratioStr) > parseFloat(30)) {
        this.revenueSharingCfgList[index].ratioStr = '30';
      }
      if (this.revenueSharingCfgList[index].ratioStr.length > 5) {
        this.revenueSharingCfgList[index].ratioStr = this.revenueSharingCfgList[index].ratioStr.slice(0, 5);
      }
      if (parseFloat(this.revenueSharingCfgList[index].ratioStr) > parseFloat(100)) {
        this.revenueSharingCfgList[index].ratioStr = '100';
      }
      this.getCheckedSharingData();
    },

    //支持分账天数改变
    changeLedgerDays(val) {
      if (parseInt(this.ruleForm.orderCompleteEndTime) > parseInt(val)) return;
      this.ruleForm.orderCompleteEndTime = val + 1;
    },

    //分账比例改变
    changeSharingType() {
      this.getCheckedSharingData();
      this.$refs.ruleForm.validateField('checkSharingType');
    },

    getCheckedSharingData () {
      this.checkedSharingData = this.revenueSharingCfgList.filter(item => this.ruleForm.checkSharingType.includes(item.type));
    },

    //取消
    handleCancel() {
      this.clearVaild();
      this.$emit("close-dialog", false);
    },

    //保存
    handleSave(ruleForm) {
      this.getCheckedSharingData()
      let params = {
        instId: this.instId,
        revenueSharingCfgList: this.checkedSharingData,
        sharingTimeList: Array.of(this.ruleForm.orderCompleteStartTime, this.ruleForm.orderCompleteEndTime)
      }
      let header = this.encryptionUtil.signatureBody(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'POST',
        url: Constant.URL_SAVE_OR_UPDATE_INST_REVENUE_SHARING_CFG_LIST_V32,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };

      this.$refs[ruleForm].validate((valid) => {
        if (!valid) return;
        this.vueRequest(requestData).then((result) => {
          if (result == null) {
            return;
          }
          this.$emit("close-dialog", true);
          this.clearVaild();
        });
      });
    },

    clearVaild() {
      this.ruleForm.checkSharingType = [];
    	this.$nextTick(() => {
        this.$refs["ruleForm"].clearValidate();
      });
		},
  },
}
</script>

<style scoped>
.sharing-setup-body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.dialog-footer {
	text-align: center;
}

.sharing-setup-body .section-item {
   margin: 5px 0 30px 9px;
}

.sharing-setup-body .section-item-head {
  display: flex;
  align-items: center;
  text-align: left;
  margin-bottom: 30px;
}

.sharing-setup-body .section-item-head span {
  font-size: 14px;
  color: #657180;
}

.sharing-setup-body .blue-line {
  width: 3px;
  height: 20px;
  background: #3E7EF5;
  margin-right: 9px;
}

.sharing-setup-body .section-item-form-item {
  margin-left: 34px;
}

.sharing-setup-body .des-style {
  font-weight: 400;
  font-size: 12px;
  color: #949494;
}

.sharing-setup-body .el-checkbox {
  display: block;
}

.sharing-setup-body .el-form-item__content .el-input-group {
  vertical-align: middle !important;
}

.sharing-setup-body .sharing-content-label {
  display: inline-block;
  width:56px;
  text-align:right;
  color:#657180
}
</style>


// WEBPACK FOOTER //
// src/components/mchmng/components/SharingSetup.vue